export const ExclusiveComponentsConstants = {
    BLIP_CHAT_COPY_AND_PASTE_VERSION: '1.0',
    BLIP_CHAT_COPY_AND_PASTE_TYPE: 'application/vnd.lime.copy-and-paste+json',
    BLIP_CHAT_COPY_AND_PASTE_PREFIX: 'blip-chat-copy-and-paste:',
    BLIP_CHAT_COPY_AND_PASTE_ACTION_NAME: 'blipChatCopyAndPaste',
};
